<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="handleExport"
        ><i class="el-icon-download"></i> 导出</el-button
      >
      <BaseTable
        ref="baseTable"
		show-summary
        url="/admin/CensusReport/cdCensus"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
		@sortChange="sortChange"
      >
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "cdtj",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {
        date: [],
      },
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
  },
  methods: {
	  
	
	bubbleSortMultiDim(arr) {  
		let temparr = arr;
	    let len = temparr.length;  
	    for (let i = 0; i < len - 1; i++) {  
	        for (let j = 0; j < len - 1 - i; j++) {  
	            // 如果当前元素大于下一个元素，则交换它们  
	            if (temparr[j].outNum > temparr[j + 1].outNum) {  
	                // 使用解构赋值进行交换  
	                [temparr[j], temparr[j + 1]] = [temparr[j + 1], temparr[j]];  
	            }  
	        }  
	    }  
	    return temparr;  
	},
	
	sortChange(item){
		// console.log(item.label);
		// console.log(item.order);
		this.tableData = this.bubbleSortMultiDim(this.tableData);
		console.log(this.tableData);
		
	},
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
    add() {},
    edit(row) {
      console.log(row);
    },
    del(row) {
      console.log(row);
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    async handleExport() {
      const res = await this.$api.post(
        "/admin/CensusReport/cdCensus",
        { is_export: 1, ...this.searchData },
        "导出"
      );
      console.log(res);
      window.open("https://" + res.data);
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      const beginTime = params.date ? params.date[0] : '';
      const endTime = params.date ? params.date[1] : '';

      return {
        ...params,
        beginTime,
        endTime,
      };
    },
  },
};
</script>
